export const FACET_FILTER_SEPARATOR = '&';
export const FACET_FILTER_PREFIX = 'f_';
export const FACET_FILTER_KEY_SEPERATOR = '=';
export const HERO_FILTER_KEY_SEPARATOR = ':';
export const HERO_FILTER_SEPARATOR = '/';
export const FILTER_VALUE_SEPARATOR = '.';
export const NUMERIC_FILTER_VALUE_SEPARATOR = '-';
